/* Infinite Options remains the price source; this only formats its output
   and passes the displayed total to the existing Afterpay component. */
(() => {
  function connect() {
    document.querySelectorAll('.wt-product__info').forEach(info => {
      if (info.dataset.holidaePriceConnected) return;
      info.dataset.holidaePriceConnected = 'true';
      let scheduled = false;
      let display;
      const cleanMoney = value => value.trim().replace(/\.00(?=\s|$)/, '').replace(/\s+AUD$/, '');
      const sync = () => {
        scheduled = false;
        const block = info.querySelector('.infiniteoptions-price');
        if (!block) return;
        const prices = [...block.querySelectorAll('.price-item')];
        const current = prices.find(el => el.classList.contains('price-item--sale') && el.getClientRects().length)
          || prices.find(el => el.classList.contains('price-item--regular') && el.getClientRects().length);
        if (!current) return;
        // AUD/USD storefront formatting only; fail closed for unfamiliar formats.
        const match = current.textContent.trim().match(/^(?:[AU]S?\$|\$)\s*([\d,]+(?:\.\d{2})?)(?:\s+(?:AUD|USD))?$/);
        if (!match) {
          if (display) display.hidden = true;
          block.classList.remove('holidae-price-source');
          block.removeAttribute('aria-hidden');
          return;
        }
        const amount = Number(match[1].replace(/,/g, ''));
        if (!Number.isFinite(amount)) return;
        if (!display || !display.isConnected) {
          display = document.createElement('div');
          display.className = 'holidae-selected-total';
          display.setAttribute('aria-live', 'polite');
          display.setAttribute('aria-atomic', 'true');
          block.after(display);
        }
        display.hidden = false;
        const compare = prices.find(el => el !== current && el.getClientRects().length && el.textContent.trim());
        const compareText = compare ? cleanMoney(compare.textContent) : '';
        const totalText = cleanMoney(current.textContent);
        const signature = compareText + '|' + totalText;
        if (display.dataset.value !== signature) {
          display.dataset.value = signature;
          display.replaceChildren();
          if (compareText) {
            const old = document.createElement('s');
            old.textContent = compareText;
            old.setAttribute('aria-label', 'Regular price ' + compareText);
            display.append(old, document.createTextNode(' '));
          }
          const total = document.createElement('span');
          total.textContent = totalText;
          total.setAttribute('aria-label', (compareText ? 'Sale price ' : 'Price ') + totalText);
          display.append(total);
        }
        // Keep the app's original text intact: its price observer uses it.
        block.classList.add('holidae-price-source');
        block.setAttribute('aria-hidden', 'true');
        info.querySelectorAll('square-placement[data-amount]').forEach(placement => {
          const value = amount.toFixed(2);
          if (Number(placement.getAttribute('data-amount')) !== amount) placement.setAttribute('data-amount', value);
        });

      };
      const observer = new MutationObserver(() => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
      });
      observer.observe(info, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-amount']});
      sync();
    });
  }
  connect();
  document.addEventListener('shopify:section:load', connect);
})();
